import { useMediaQuery } from "@mantine/hooks"

/**
 * Wrapper around the useMediaQuery hook from Mantine
 * that accepts `theme.fn.largerThan() and theme.fn.smallerThan() media queries.
 */
export const useBreakpoint = (queryString: string) => {
    const breakpointWithoutMedia = queryString.replace("@media ", "")
    return useMediaQuery(breakpointWithoutMedia)
}
